import React, { useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import faqBanner from "../../Images/student-services/scholarship.92e266f5745dc3958918.webp";
import scolr1 from "../../Images/student-services/scolr-1.webp";
import scolr2 from '../../Images/student-services/scolr-2.webp';
import scolr3 from '../../Images/student-services/scolr-3.webp';
import scolr4 from '../../Images/student-services/scolr-4.webp';
import classroomImage from "../../Images/student-services/scholarship.webp";
import { Row } from "react-bootstrap";

const scholarshipData = [
    {
        title: 'ISBM University is a proud sponsor of “Shushiksha" Chhattisgarh',
        image: scolr1,
        alt: 'Sponsor of Shushiksha Chhattisgarh',
        description: `ISBM University is a proud sponsor of “Shushiksha" Chhattisgarh an Education Conclave 2018. 
        Education Conclave was an effort to bring together Policy Makers, Institution Heads, Decision Makers, 
        Industry HR Officials and Edu-tech Players under one roof to explore the various space in the Education field.`,
    },
    {
        title: 'ISBM University has been fortunate to host several scholarship',
        image: scolr2,
        alt: 'ISBM university scholarship',
        description: `ISBM University has been fortunate to host several scholarship awarding events for the students. 
        These events have been graced by the supremos of the state Dr. Raman Singh (Former Chief Minister of Chhattisgarh) 
        and Shri Bhupesh Baghel (Chief Minister of Chhattisgarh) who have awarded scholarship certificates to the deserving students.`,
    },
    {
        title: 'We offer an array of scholarships for the deserving students',
        image: scolr3,
        alt: 'ISBM university scholarship',
        description: `We offer an array of scholarships for the deserving students. It has been a constant effort of ISBM 
        to work towards the upliftment of underprivileged population of the region. We also believe in positive discriminatory 
        treatment of girls and women to educate them in the realm of higher education. ISBM is providing various scholarships 
        for students enrolling in various academic programmes. More information can be found at 
        <a href="#" class="text-dark fs-7">www.isbmuniversity.edu.in</a>.`,
    },
    {
        title: 'A number of Scholarships are offered to students out of the funds',
        image: scolr4,
        alt: 'ISBM university scholarship',
        description: `A number of Scholarships are offered to students out of the funds received in the form of gifts from 
        the University benefactors, depending on the academic. The University grants full to partial waiver on tuition fees 
        payable by the student. We extend scholarship to meritorious students based on their academic achievements, caste, 
        gender in accordance with Government norms and ISBM University's policy. Money is not a constraint to pursue higher 
        education; ISBM University also aids the aspirants with education loans to pursue their dreams.`,
    },
];

const Scholarship = () => {
    const [active, setActive] = useState(0);

    return (
        <>
            <title>Scholarship Opportunities | ISBM University</title>
            <meta
                name="description"
                content="ISBM University offers diverse scholarship programs to support your studies. Learn how to qualify, apply & succeed with financial aid. Apply now."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${faqBanner})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Scholarship</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Scholarship
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-light">
                <div className="container-xxl ptb-50">
                    <Row className="m-0">
                        <div className="col-md-6">
                            <h2 className="modern-title text-blue">Scholarship Opportunities</h2>
                            <div className="underline-divider mb-3"></div>
                            <p className="text-muted">
                                At ISBM University, we believe that financial constraints should
                                never be a barrier to quality education. To support deserving and
                                meritorious students, the university offers a range of scholarships
                                across various programs. These scholarships are awarded based on
                                academic performance, socio-economic background, and special
                                achievements in sports or extracurricular activities.
                            </p>
                            <p className="text-muted">
                                Our scholarship programs are designed to encourage excellence
                                and reward students who demonstrate commitment, leadership, and
                                strong academic potential. Eligible students can apply during the
                                admission process, and selected candidates receive financial
                                assistance in the form of tuition fee waivers or reductions.
                                ISBM University is committed to nurturing talent and providing
                                equal opportunities to help every student reach their full potential.
                            </p>
                        </div>
                        <div className="col-md-6">
                            <div className="governing-image-wrapper shadow">
                                <img src={classroomImage} alt="Laptop with rolled certificate tied with red ribbon and glasses on desk" />
                            </div>
                        </div>
                    </Row>
                </div>
            </section>

            <section className="container-xxl ptb-50">
                <h2 className="linkabout123 mb-4">Scholarship</h2>
                <div className="underline-divider mb-3"></div>
                <div className="row">
                    {/* Button List */}
                    <div className="col-lg-4 mb-4">
                        <div className="btn-group-vertical w-100 gap-2 d-flex flex-column">
                            {scholarshipData.map((item, index) => (
                                <button
                                    key={index}
                                    className={`btn btn-outline-primary shadow mb-2 rounded-3 text-start ${active === index ? "active" : ""}`}
                                    onClick={() => setActive(index)}
                                >
                                    {item.title}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Scholarship Card */}
                    <div className="col-lg-8">
                        <div className="card border-0 shadow-lg">
                            <div className="row g-0 align-items-center">
                                <div className="col-md-5">
                                    <img
                                        src={scholarshipData[active].image}
                                        alt={scholarshipData[active].alt}
                                        className="img-fluid scolar rounded-start w-100 h-100 object-fit-cover"
                                    />
                                </div>
                                <div className="col-md-7">
                                    <div className="card-body">
                                        <div
                                            className="card-text text-black"
                                            dangerouslySetInnerHTML={{ __html: scholarshipData[active].description }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Scholarship;
